import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';
import { ApiService } from '../../services/api.service';
import { Global } from '../../global';
import { Router } from '@angular/router';

@Component({
  selector: 'app-realizar-ponto',
  templateUrl: './realizar-ponto.component.html',
  styleUrls: ['./realizar-ponto.component.css']
})
export class RealizarPontoComponent implements OnInit {

  loading = true;
  ponto: any = {};
  listaUnidades: any = [];
  listaSetores: any = [];
  validaFuncionario: boolean = false;
  dadosPonto: any = {};
  loadData: boolean = false;
  setorUuid: string;
  setorNome: string;
  unidadeUuid: string;
  unidadeNome: string;

  constructor(
    private apiService: ApiService,
    public global: Global,
    private router: Router,
  ) { }

  ngOnInit() {
    this.obterUnidades();
  }

  obterUnidades = () => {
    this.loading = true;
    this.apiService.Get("Unidades").then(
      result => {
        this.listaUnidades = result;
        this.loading = false;
        //this.listaUnidades.unshift({nome:'hudson'});
        this.obterSetores(this.listaUnidades[0].uuid);
        this.unidadeNome = this.listaUnidades[0].nome;
        this.unidadeUuid = this.listaUnidades[0].uuid;
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
    this.loading = false;
  }

  obterSetores = (unidade) => {
    this.loading = true;
    //console.log(unidade.uuid);
    this.apiService.Get("Unidades/"+unidade+"/Setores").then(
      result => {
        this.listaSetores = result;
        this.loading = false;
        this.setorNome = this.listaSetores[0].nome;
        this.setorUuid = this.listaSetores[0].uuid;
        this.loadData = true;
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
    this.loading = false;
  }

  tirarFoto = () => {
    this.validaFuncionario = !this.validaFuncionario;
  }

  carregarPagina = (retornarFiltro:boolean) => {
    this.validaFuncionario = retornarFiltro;
    this.loadData = false;
    this.obterUnidades();
  }

  setLoading = () => {
    this.loading = !this.loading;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/realizar-ponto/realizar-ponto.component.ts